import BKCWLogo from 'core/images/tenantLogos/BKCW.png';
import CBSLogo from 'core/images/tenantLogos/CBS.png';
import CobbsAllen from 'core/images/tenantLogos/cobbsAllen.png';
import DeanAndDraperLogo from 'core/images/tenantLogos/deananddraper.png';
import EllerbrockLogo from 'core/images/tenantLogos/EllerbrockNorris.png';
import HeffernanLogo from 'core/images/tenantLogos/Heffernan.png';
import HUBLogo from 'core/images/tenantLogos/Hub.png';
import IMALogo from 'core/images/tenantLogos/IMA.png';
import InsuranceLogo from 'core/images/tenantLogos/InsurorsGroup.png';
import InsurorsOfTexasLogo from 'core/images/tenantLogos/insurorsoftexas.png';
import KapnickLogo from 'core/images/tenantLogos/kapnick.png';
import NSILogo from 'core/images/tenantLogos/NSI.png';
import OneGroupLogo from 'core/images/tenantLogos/onegroup.png';
import PanoramaLogo from 'core/images/tenantLogos/Panorama-360.png';
import PathfinderLogo from 'core/images/tenantLogos/Pathfinder.png';
import TexCapLogo from 'core/images/tenantLogos/TexCap.png';
import UpshawLogo from 'core/images/tenantLogos/Upshaw.png';
import UnisonLogo from 'core/images/tenantLogos/unison.png';
import RiemerLogo from 'core/images/tenantLogos/riemer.png';
import SwingleCollinsLogo from 'core/images/tenantLogos/SwingleCollins.png';
import PeopleFirstLogo from 'core/images/tenantLogos/PeopleFirst.png';
import AlliantLogo from 'core/images/tenantLogos/Alliant.png';
import SymphonyRisk from 'core/images/tenantLogos/SymphonyRiskSolutions.png';
import ThreeArbor from 'core/images/tenantLogos/ThreeArborsInsurance.png';
import KingRiskPartners from 'core/images/tenantLogos/KingRiskPartners.png';
import WeInsure from 'core/images/tenantLogos/WeInsure.png';
import UnicoLogo from 'core/images/tenantLogos/Unico.png';
import BaldwinGroupLogo from 'core/images/tenantLogos/BaldwinGroup.png';
import TedrickGroupLogo from 'core/images/tenantLogos/TedrickGroup.png';
import TMG from 'core/images/tenantLogos/TMG.png';
import Interwest from 'core/images/tenantLogos/Interwest.png';
import BaylessHall from 'core/images/tenantLogos/BaylessHall.png';
import CraneAgencyLogo from 'core/images/tenantLogos/CraneAgency.png';
import OneDigitalLogo from 'core/images/tenantLogos/oneDigital.png';
import ChoiceFinancialGroupLogo from 'core/images/tenantLogos/choiceFinancialGroupLogo.png';
import AlkemeLogo from 'core/images/tenantLogos/alkeme.png';
import BucknerLogo from 'core/images/tenantLogos/Buckner.png';
import YourPolicyLogo from 'core/images/tenantLogos/YourPolicy.png';
import ISULogo from 'core/images/tenantLogos/ISU.png';
import MavrixLogo from 'core/images/tenantLogos/Mavrix.png';
import PIIBLogo from 'core/images/tenantLogos/PIIB.png';
import TeagueLogo from 'core/images/tenantLogos/teague.png';
import CBIZLogo from 'core/images/tenantLogos/CBIZ.png';
import C3Logo from 'core/images/tenantLogos/C3.png';
import FordInsuranceLogo from 'core/images/tenantLogos/FordInsuranceAgency.png';
import TPG from 'core/images/tenantLogos/TPG.png';
type TenantItem = {
  logo: string;
};

export const TenantLogoIconMap: Record<string, TenantItem> = {
  bu5nwr: {
    logo: AlliantLogo,
  },
  bnftnu: {
    logo: DeanAndDraperLogo,
  },
  bsw5zd: {
    logo: InsuranceLogo,
  },
  b5wzid: {
    logo: PanoramaLogo,
  },
  bcgf0a: {
    logo: PathfinderLogo,
  },
  bdgv4y: {
    logo: TexCapLogo,
  },
  bvxbza: {
    logo: UpshawLogo,
  },
  bcdhwe: {
    logo: UnisonLogo,
  },
  bq0jti: {
    logo: CBSLogo,
  },
  bjy6db: {
    logo: HeffernanLogo,
  },
  bsu1bc: {
    logo: IMALogo,
  },
  bsfvcc: {
    logo: HUBLogo,
  },
  btlnjc: {
    logo: NSILogo,
  },
  bzdx3v: {
    logo: InsurorsOfTexasLogo,
  },
  b2dppa: {
    logo: EllerbrockLogo,
  },
  b82zmv: {
    logo: OneGroupLogo,
  },
  bs2fwb: {
    logo: KapnickLogo,
  },
  bynjwc: {
    logo: BaldwinGroupLogo,
  },
  bqktdv: {
    logo: BKCWLogo,
  },
  bhuucu: {
    logo: CobbsAllen,
  },
  bmsdte: {
    logo: RiemerLogo,
  },
  bpqpax: {
    logo: SwingleCollinsLogo,
  },
  bvdxxt: {
    logo: PeopleFirstLogo,
  },
  ba9tz8: {
    logo: SymphonyRisk,
  },
  bjflx3: {
    logo: ThreeArbor,
  },
  bt5eua: {
    logo: KingRiskPartners,
  },
  b8dxnq: {
    logo: WeInsure,
  },
  byjyyq: {
    logo: UnicoLogo,
  },
  bsyjrs: {
    logo: TedrickGroupLogo,
  },
  b9jkdc: {
    logo: Interwest,
  },
  bsqasg: {
    logo: TMG,
  },
  bqmf5b: {
    logo: BaylessHall,
  },
  buztkn: {
    logo: CraneAgencyLogo,
  },
  behpng: {
    logo: OneDigitalLogo,
  },
  bp2zoz: {
    logo: ChoiceFinancialGroupLogo,
  },
  bjb3eu: {
    logo: AlkemeLogo,
  },
  bumqes: {
    logo: BucknerLogo,
  },
  bgevvb: {
    logo: YourPolicyLogo,
  },
  bstot5: {
    logo: ISULogo,
  },
  b8qybs: {
    logo: MavrixLogo,
  },
  bl7mcb: {
    logo: PIIBLogo,
  },
  bobrwn: {
    logo: TeagueLogo,
  },
  bq2rps: {
    logo: CBIZLogo,
  },
  bsupj5: {
    logo: CBIZLogo,
  },
  bv3wu3: {
    logo: C3Logo,
  },
  bgaruk: {
    logo: FordInsuranceLogo,
  },
  bwmr6m: {
    logo: TPG,
  }
};
